import { Point } from 'generated/leaderboard-client';

import { DataPoint } from './data-point-related';
import { selectChartDisplayValue } from './float-series-view-primitives';

type PointWithOriginalMetadata = Point & { step?: number; timestampMillis?: number };

function converterPointFromApiToDomain(point: Point): DataPoint {
  const { step: originalStep, timestampMillis } = point as PointWithOriginalMetadata;
  const y = selectChartDisplayValue(point);
  const minY = point.bucket?.minY ?? y;
  const maxY = point.bucket?.maxY ?? y;

  const result: DataPoint = [
    point.x,
    point.bucket?.count === 0 ? Infinity : [minY, y, maxY],
    undefined, // unused
    undefined, // averaging data (only present in points generated by averaging)
    point.interpolation,
    point.bucket && {
      sum: point.bucket.sum,
      count: point.bucket.count,
      positiveInfCount: point.bucket.positiveInfCount || 0,
      negativeInfCount: point.bucket.negativeInfCount || 0,
      nanCount: point.bucket.nanCount || 0,
    },
  ];

  if (Number.isFinite(originalStep)) {
    result[6] = originalStep;
  }

  if (Number.isFinite(timestampMillis)) {
    result[7] = timestampMillis;
  }

  return result;
}

export function convertSeriesPointsFromApiToDomain(values: Array<Point>): DataPoint[] {
  return values.map((point) => converterPointFromApiToDomain(point));
}
